import React from "react";

class RichNut extends React.Component {
    value = "";
    color = "";

    constructor(props) {
        super(props);

        let food = this.props.data;
        let tot = food.carbs + food.fats + food.prots;
        let carbsPct = food.carbs * 100 / tot;
        let fatsPct = food.fats * 100 / tot;
        let protsPct = food.prots * 100 / tot;

        if (carbsPct > 50) {
            this.color = "glowB";
            if (carbsPct > 75) this.value = "+Rico en Carbs";
            else this.value = "Rico en Carbs";
        } else if (fatsPct > 50) {
            this.color = "glowA";
            if (fatsPct > 65) this.value = "+Rico en Grasas";
            else this.value = "Rico en Grasas";
        } else if (protsPct > 50) {
            this.color = "glowC";
            if (protsPct > 75) this.value = "+Rico en Prots";
            else this.value = "Rico en Prots";
        }
    }

    render() {
        return <span className={this.color}>{this.value}</span>;
    }
}

export default RichNut;
